import { connect } from 'react-redux';
import { TRootState } from '../../../../store';
import { areSearchResultsVisible } from '../../selectors';

const mapStateToProps = (state: TRootState) => ({
    areSearchResultsVisible: areSearchResultsVisible(state),
});

const mapDispatchToProps = {};

type TStateProps = ReturnType<typeof mapStateToProps>;
type TDispatchProps = typeof mapDispatchToProps;

export type TConnectableProps = TStateProps & TDispatchProps;

export const Connectable = connect(mapStateToProps, mapDispatchToProps);
